module.exports = __webpack_public_path__ + "static/media/Game-example.7939bdf4.gif";